import PageTitle from "components/PageTitle/PageTitle";
import PageFrame from "components/Panels/PageFrame";
import CardManageWrapper from "./CardManageWrapper";

const CardManageService = () => {
  return (
    <PageFrame
      children={
        <div>
          <PageTitle titleText="카드관리" />
          <CardManageWrapper />
        </div>
      }
    />
  );
};
export default CardManageService;
